// Single HTTP entry point for the portal.
// - REACT_APP_USE_MOCK !== 'false' -> requests are served by src/api/mock (no backend needed)
// - otherwise -> fetch() against REACT_APP_API_BASE_URL
// Responses use the envelope { success, data, message, errors }; callers receive `data`.
import storageService from '../services/storageService';
import { ApiError, buildQuery } from './helpers';
import { mockRequest } from './mock/server';

export const USE_MOCK = process.env.REACT_APP_USE_MOCK !== 'false';
const BASE_URL = (process.env.REACT_APP_API_BASE_URL || '').replace(/\/$/, '');
const CLINIC_ID = process.env.REACT_APP_CLINIC_ID || '';

export const AUTH_EXPIRED_EVENT = 'cp:auth-expired';

const handle = ({ status, body }) => {
  if (status === 401) window.dispatchEvent(new Event(AUTH_EXPIRED_EVENT));
  if (status >= 400 || !body || body.success === false) {
    throw new ApiError(body?.message || 'Something went wrong. Please try again.', status, body?.errors);
  }
  return body.data;
};

async function request(method, url, { params, data } = {}) {
  const token = storageService.getToken();

  if (USE_MOCK) {
    return handle(await mockRequest({ method, url, params, data, token }));
  }

  let res;
  try {
    res = await fetch(`${BASE_URL}${url}${buildQuery(params)}`, {
      method,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        ...(CLINIC_ID && { 'X-Clinic-Id': CLINIC_ID }),
        ...(token && { Authorization: `Bearer ${token}` }),
      },
      body: data ? JSON.stringify(data) : undefined,
    });
  } catch (e) {
    throw new ApiError('Unable to connect. Check your internet connection and try again.');
  }
  const body = await res.json().catch(() => null);
  return handle({ status: res.status, body });
}

const client = {
  get: (url, params) => request('GET', url, { params }),
  post: (url, data) => request('POST', url, { data }),
  put: (url, data) => request('PUT', url, { data }),
  patch: (url, data) => request('PATCH', url, { data }),
  delete: (url) => request('DELETE', url),
};

export default client;
